import {useMemo} from 'react';
import {useAuth} from 'users';
import styles from './question_counts.module.css';

export const QuestionCounts = ({questions, visibleQuestions}: Props) => {
  const {user, isReady, hasPermission} = useAuth();
  const [companies, positions] = useMemo(() => {
    const companyCounter: Record<string, boolean> = {};
    const positionCounter: Record<string, boolean> = {};
    questions.forEach((question) => {
      question.companies.forEach((company) => (companyCounter[company.company] = true));
      question.positions.forEach((position) => (positionCounter[position.position] = true));
    });
    let companies_response = '';
    if (user && user.loggedIn && isReady && hasPermission('question_company_filter')) {
      companies_response = `from ${Object.keys(companyCounter).length} compan${
        Object.keys(companyCounter).length === 1 ? 'y' : 'ies'
      }`;
    }

    return [
      companies_response,
      ` for ${Object.keys(positionCounter).length} position${
        Object.keys(positionCounter).length === 1 ? '' : 's'
      }`,
    ];
  }, [questions]);

  return (
    <p className={styles.counts}>
      {visibleQuestions.length === questions.length
        ? `Showing ${questions.length}`
        : `Showing only ${visibleQuestions.length} of ${questions.length}`}{' '}
      interview questions {companies}
      {positions}.
    </p>
  );
};

type Props = {
  questions: Question[];
  visibleQuestions: Question[];
};
